var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleCaretUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6.58035e-05 15.2425C-6.58035e-05 15.05 0.0645332 14.8575 0.202963 14.7056L6.22 8.10032C7.19823 7.02646 8.80401 7.02646 9.78224 8.10032L15.7993 14.7056C16.0669 14.9994 16.0669 15.4856 15.7993 15.7794C15.5316 16.0732 15.0887 16.0732 14.821 15.7794L8.80401 9.17418C8.36104 8.6879 7.64121 8.6879 7.19823 9.17418L1.18119 15.7794C0.913565 16.0732 0.470591 16.0732 0.202963 15.7794C0.0737619 15.6275 -6.58035e-05 15.435 -6.58035e-05 15.2425Z",
    fill: "#655B96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.58035e-05 7.94758C-6.58035e-05 7.75509 0.0645332 7.56261 0.202963 7.41065L6.22 0.805395C7.19823 -0.268465 8.80401 -0.268465 9.78224 0.805395L15.7993 7.41065C16.0669 7.70444 16.0669 8.19071 15.7993 8.48451C15.5316 8.7783 15.0887 8.7783 14.821 8.48451L8.80401 1.87926C8.36104 1.39298 7.64121 1.39298 7.19823 1.87926L1.18119 8.48451C0.913565 8.7783 0.470591 8.7783 0.202963 8.48451C0.0737619 8.33255 -6.58035e-05 8.14006 -6.58035e-05 7.94758Z",
    fill: "#655B96"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCaretUp);
export default __webpack_public_path__ + "static/media/DoubleCaretUp.fa30b5efde3ec7cb810cc100676cb7f7.svg";
export { ForwardRef as ReactComponent };